import ABSUtils from '@abs/utils';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Hidden from '@mui/material/Hidden';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

const Root = styled('div')(({ theme }) => ({
  '&.user': {
    '& .username, & .email': {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    }
  },
	'& .avatar': {
		transition: theme.transitions.create('all', {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		}),
		bottom: 0,
		'& > img': {
			borderRadius: '50%'
		}
	}
}));

function UserNavbarHeaderNew(props) {
	const user = useSelector(({ user }) => user);

	return (
    <Root className={props.className}>
      <AppBar
        position="static"
        color="primary"
        className={"user relative flex flex-col items-center justify-center pt-8 pb-64 mb-16 z-10 shadow-0"}
      >
        <Hidden lgUp>
          <Typography className="text-20 leading-none font-medium logo-text mb-12 px-12" color="inherit">
            {user.CompanyName}
          </Typography>
        </Hidden>
        <Typography className="username text-16 whitespace-nowrap font-semibold mb-4" color="inherit">
          {user.User_Firstname + " " + user.User_Name}
        </Typography>
        <Typography className="email text-13 opacity-50 whitespace-nowrap font-medium" color="inherit">
          {user.E_Mail}
        </Typography>
        <div className="flex items-center justify-center absolute bottom-0 -mb-44">
          {user.ProfilePicture && user.ProfilePicture !== '' ?
            <Avatar
              className='avatar w-72 h-72 p-8 box-content'
              alt="user photo"
              src={user.ProfilePicture}/>
          :
            <Avatar sx={ user.Color && { bgcolor: user.Color, color: ABSUtils.invertColor(user.Color, true) }} className={clsx('avatar w-72 h-72 p-8 box-content')}>{ABSUtils.getAvatarFallbackCharArray(user.User_Firstname + " " + user.User_Name)}</Avatar>
          }
        </div>
      </AppBar>
    </Root>
	);
}

export default UserNavbarHeaderNew;
